/* LP Anniversaire Bobochic 10 ans – BA-2485 – portage Shopify */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 899px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function isMobile() { return mq.matches; }
  function pick(el) { return (isMobile() && el.dataset.srcMobile) || el.dataset.src || ''; }
  function pickVid(v) { return (isMobile() && v.dataset.srcMobile) || v.dataset.srcPc || ''; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function focus(el) { if (!el || !el.focus) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function play(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
  }

  /* verrou de scroll (modales empilables) */
  var locks = 0;
  function lock(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.documentElement.style.overflow = locks ? 'hidden' : '';
  }

  function build(kind, src, alt) {
    if (kind === 'image') { var i = new Image(); i.decoding = 'async'; i.alt = alt || ''; i.src = src; return i; }
    var v = document.createElement('video');
    v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto'; v.src = src;
    return v;
  }

  /* ---------- scroll global (rAF) ---------- */
  var scrollFns = [], sRaf = 0;
  function onWinScroll() {
    if (sRaf) return;
    sRaf = requestAnimationFrame(function () { sRaf = 0; scrollFns.forEach(function (f) { f(); }); });
  }
  window.addEventListener('scroll', onWinScroll, { passive: true });
  window.addEventListener('resize', onWinScroll);

  /* ---------- Échap : ferme la couche la plus haute ---------- */
  var escStack = [];
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    for (var i = 0; i < escStack.length; i++) {
      if (escStack[i].isOpen()) { escStack[i].close(); return; }
    }
  });

  /* ---------- vidéos miniatures (lazy + pause hors écran) ---------- */
  var vidIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      var tvOff = v.closest('[data-tv]:not(.is-on), [data-tvm]:not(.is-on)');
      if (e.isIntersecting && !tvOff) {
        if (!v.getAttribute('src')) v.src = pickVid(v);
        v.muted = true; play(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '150px' }) : null;

  function watchVids(scope) {
    $$('video.lp-lazyvid', scope).forEach(function (v) {
      if (vidIO) { vidIO.unobserve(v); vidIO.observe(v); }
      else if (!v.getAttribute('src')) { v.src = pickVid(v); v.muted = true; play(v); }
    });
  }
  function pauseVids(scope) { $$('video.lp-lazyvid', scope).forEach(function (v) { v.pause(); }); }

  /* ---------- hero ---------- */
  function heroVideo(root) {
    $$('.ab-hero__video', root).forEach(function (v) {
      var src = pickVid(v);
      if (src && v.getAttribute('src') !== src) v.src = src;
      v.muted = true; play(v);
    });
  }

  function heroFilm(root) {
    var btn = $('[data-ab-openfilm]', root), hero = $('.ab-hero', root);
    if (!btn || !hero) return null;
    var layer = null, vid = null;
    var EASE = '700ms cubic-bezier(.22,1,.36,1)';

    function rectOf(el) { var r = el.getBoundingClientRect(); return { top: r.top, left: r.left, width: r.width, height: r.height }; }
    function full() { return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }; }
    function apply(v, r) { v.style.top = r.top + 'px'; v.style.left = r.left + 'px'; v.style.width = r.width + 'px'; v.style.height = r.height + 'px'; }

    function open() {
      if (layer) return;
      layer = document.createElement('div');
      layer.className = 'ab-herofilm';
      layer.setAttribute('role', 'dialog');
      layer.setAttribute('aria-modal', 'true');
      layer.setAttribute('aria-label', root.dataset.labelFilm || 'Film des 10 ans');
      layer.innerHTML = '<button type="button" class="ab-herofilm__close"><span aria-hidden="true"></span></button>';
      layer.querySelector('.ab-herofilm__close').setAttribute('aria-label', root.dataset.labelClose || 'Fermer');
      vid = document.createElement('video');
      vid.className = 'ab-herofilm__video';
      vid.controls = true; vid.playsInline = true; vid.setAttribute('playsinline', '');
      vid.style.objectFit = 'contain';
      vid.src = isMobile() ? root.dataset.filmMobile : root.dataset.filmDesktop;
      apply(vid, rectOf($('.ab-hero__video', root) || hero));
      layer.appendChild(vid);
      root.appendChild(layer);
      hero.classList.add('ab-hero--film');
      lock(true);
      layer.querySelector('.ab-herofilm__close').addEventListener('click', close);
      vid.addEventListener('ended', close);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!layer) return;
          layer.classList.add('is-on');
          if (!reduce) vid.style.transition = ['top', 'left', 'width', 'height'].map(function (p) { return p + ' ' + EASE; }).join(',');
          apply(vid, full());
          play(vid);
        });
      });
      focus(layer.querySelector('.ab-herofilm__close'));
    }

    function close() {
      if (!layer) return;
      var l = layer, v = vid; layer = null; vid = null;
      v.pause();
      l.classList.remove('is-on');
      hero.classList.remove('ab-hero--film');
      lock(false);
      var hv = $('.ab-hero__video', root);
      if (hv && !reduce) apply(v, rectOf(hv));
      setTimeout(function () { if (l.parentNode) l.parentNode.removeChild(l); }, reduce ? 0 : 700);
      focus(btn);
    }

    btn.addEventListener('click', open);
    window.addEventListener('resize', function () { if (layer && vid) apply(vid, full()); });
    return { close: close, isOpen: function () { return !!layer; } };
  }

  /* ---------- neige (écran éteint) ---------- */
  var snowURL = null;
  function snow(root) {
    var els = $$('[data-snow]', root);
    if (!els.length) return;
    if (!snowURL) {
      var c = document.createElement('canvas'); c.width = c.height = 128;
      var x = c.getContext('2d'), d = x.createImageData(128, 128);
      for (var i = 0; i < d.data.length; i += 4) {
        var n = (Math.random() * 255) | 0;
        d.data[i] = d.data[i + 1] = d.data[i + 2] = n; d.data[i + 3] = 255;
      }
      x.putImageData(d, 0, 0);
      snowURL = c.toDataURL('image/png');
    }
    els.forEach(function (s) { s.style.backgroundImage = 'url(' + snowURL + ')'; });
  }

  /* ---------- télé (desktop horizontale / mobile verticale) ---------- */
  function initTV(tv, horizontal) {
    var power = $('[data-power]', tv), off = $('[data-off]', tv), track = $('[data-track]', tv), rail = $('[data-rail]', tv);
    if (!power || !track) return null;
    var years = $$('[data-y]', track), btns = rail ? $$('[data-yb]', rail) : [];
    if (!years.length) return null;
    var chip = $('[data-chip]', tv), ghost = $('[data-ghost]', tv), osd = $('[data-osd]', tv);
    var osdCh = $('[data-osd-ch]', tv), osdTag = $('[data-osd-tag]', tv), prog = $('[data-prog]', tv);
    var media = $('[data-tvmedia]', tv), mstage = $('[data-tvmedia-stage]', tv), fade = $('.ab-tv__fade--l', tv);
    var on = false, cur = -1, timer = 0, raf = 0, lockI = -1, lockT = 0, lastBtn = null;

    function pos(el) { return horizontal ? el.offsetLeft : el.offsetTop; }
    function lead() { return horizontal ? (fade ? fade.offsetWidth * 0.6 : 64) : 0; }
    function sc() { return horizontal ? track.scrollLeft : track.scrollTop; }
    function max() { return horizontal ? track.scrollWidth - track.clientWidth : track.scrollHeight - track.clientHeight; }
    function idxOf(y) { for (var i = 0; i < years.length; i++) if (years[i].getAttribute('data-y') === y) return i; return 0; }
    function btnFor(y) { for (var i = 0; i < btns.length; i++) if (btns[i].getAttribute('data-yb') === y) return btns[i]; return null; }

    function scrollToI(i, instant) {
      var o = { behavior: (instant || reduce) ? 'auto' : 'smooth' };
      o[horizontal ? 'left' : 'top'] = Math.max(0, pos(years[i]) - lead());
      track.scrollTo(o);
    }
    function current() {
      var s = sc(), m = max();
      if (m > 0 && s >= m - 2) return years.length - 1;
      var probe = s + (horizontal ? track.clientWidth * 0.35 : 24), r = 0;
      for (var i = 0; i < years.length; i++) { if (pos(years[i]) <= probe) r = i; else break; }
      return r;
    }
    function placeChip() {
      if (!chip || cur < 0) return;
      var b = btnFor(years[cur].getAttribute('data-y'));
      if (b) chip.style.transform = 'translateX(' + (b.offsetLeft + (b.offsetWidth - chip.offsetWidth) / 2) + 'px)';
    }
    function showOSD(i) {
      if (!osd) return;
      var t = years[i].querySelector('.tl-ytag'), tag = t ? t.textContent.trim() : '';
      if (osdCh) osdCh.textContent = 'CH ' + (i < 9 ? '0' : '') + (i + 1);
      if (osdTag) { osdTag.textContent = tag; osdTag.style.display = tag ? '' : 'none'; }
      osd.classList.remove('is-show'); void osd.offsetWidth; osd.classList.add('is-show');
    }
    function setActive(i, force) {
      if (i === cur && !force) return;
      cur = i;
      var y = years[i].getAttribute('data-y');
      btns.forEach(function (b) {
        var a = b.getAttribute('data-yb') === y;
        if (b.hasAttribute('data-yearpill')) b.setAttribute('data-active', a ? 'true' : 'false');
        if (a) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (chip) { chip.textContent = y; placeChip(); }
      var b = btnFor(y);
      if (b && rail && rail.scrollWidth > rail.clientWidth) {
        var rr = rail.getBoundingClientRect(), br = b.getBoundingClientRect();
        rail.scrollTo({ left: rail.scrollLeft + br.left - rr.left - (rail.clientWidth - br.width) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (ghost) { ghost.textContent = y; ghost.classList.remove('is-flick'); void ghost.offsetWidth; ghost.classList.add('is-flick'); }
      showOSD(i);
    }
    function update(force) {
      raf = 0;
      if (prog) { var m = max(); prog.style.width = (m > 0 ? sc() / m * 100 : 0) + '%'; }
      if (!on) return;
      setActive(lockI > -1 && Date.now() < lockT ? lockI : current(), force);
    }
    function goTo(i) {
      i = clamp(i, 0, years.length - 1);
      lockI = i; lockT = Date.now() + 900;
      setActive(i); scrollToI(i);
    }

    function openMedia(b) {
      if (!media || !mstage) return;
      var im = b.querySelector('img');
      var el = build(b.dataset.kind, pick(b), im ? im.alt : '');
      mstage.innerHTML = ''; mstage.appendChild(el); media.hidden = false;
      pauseVids(tv); play(el); lastBtn = b;
      focus($('[data-tvmedia-close]', media));
    }
    function closeMedia() {
      if (!media || media.hidden) return;
      var v = $('video', mstage); if (v) v.pause();
      mstage.innerHTML = ''; media.hidden = true;
      if (on) watchVids(tv);
      focus(lastBtn); lastBtn = null;
    }

    function setOn(v) {
      if (v === on) return;
      on = v; clearTimeout(timer);
      power.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) {
        tv.classList.remove('is-closing'); tv.classList.add('is-on');
        cur = -1; update(true); watchVids(tv);
      } else {
        closeMedia(); pauseVids(tv);
        tv.classList.add('is-closing');
        scrollToI(0); /* rembobine pendant l'extinction */
        timer = setTimeout(function () { tv.classList.remove('is-on', 'is-closing'); scrollToI(0, true); cur = -1; }, 1500);
      }
    }

    power.addEventListener('click', function () { setOn(!on); });
    if (off) off.addEventListener('click', function () { setOn(true); });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = idxOf(b.getAttribute('data-yb'));
        if (on) { goTo(i); return; }
        setOn(true); setTimeout(function () { goTo(i); }, 420);
      });
    });
    var prev = $('[data-prev]', tv), next = $('[data-next]', tv);
    if (prev) prev.addEventListener('click', function () { if (on) goTo(cur - 1); else setOn(true); });
    if (next) next.addEventListener('click', function () { if (on) goTo(cur + 1); else setOn(true); });
    $$('.tl-media, .tvm-media', tv).forEach(function (b) {
      b.addEventListener('click', function () { if (on) openMedia(b); });
    });
    if (media) { var mc = $('[data-tvmedia-close]', media); if (mc) mc.addEventListener('click', closeMedia); }

    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { update(false); }); }, { passive: true });
    track.addEventListener('scrollend', function () { lockI = -1; update(false); });
    window.addEventListener('resize', function () { if (on) placeChip(); });

    if (horizontal) {
      /* clavier */
      track.addEventListener('keydown', function (e) {
        if (!on) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
      });
      /* glisser à la souris */
      var drag = null, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, s: track.scrollLeft }; moved = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        if (moved) { track.scrollLeft = drag.s - dx; lockI = -1; }
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return; drag = null;
        setTimeout(function () { track.classList.remove('is-drag'); moved = false; }, 0);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      /* molette verticale -> défilement horizontal, rend la main en bout de frise */
      track.addEventListener('wheel', function (e) {
        if (!on || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        var m = max(), s = track.scrollLeft;
        if ((e.deltaY > 0 && s < m - 1) || (e.deltaY < 0 && s > 1)) {
          e.preventDefault(); track.scrollLeft = s + e.deltaY; lockI = -1;
        }
      }, { passive: false });
    }

    return { close: closeMedia, isOpen: function () { return !!media && !media.hidden; } };
  }

  /* ---------- manifeste : reveals ---------- */
  function reveal(root) {
    var els = $$('[data-manifesto] [data-reveal]', root);
    if (!els.length) return;
    if (!hasIO) { els.forEach(function (e) { e.classList.add('rv-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.__abReveal.forEach(function (el) { el.classList.add('rv-in'); });
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) {
      /* .cr est masqué par son propre clip-path (surface visible nulle) :
         on observe son parent et on lui transmet le rv-in */
      var t = el.classList.contains('cr') ? el.parentElement : el;
      if (!t.__abReveal) { t.__abReveal = []; io.observe(t); }
      t.__abReveal.push(el);
    });
  }

  function jumpTo(wrap, i, n) {
    var top = wrap.getBoundingClientRect().top + window.pageYOffset;
    var range = wrap.offsetHeight - window.innerHeight;
    window.scrollTo({ top: top + range * (i + 0.5) / n, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- scrollytelling desktop (pin JS, robuste aux overflow du thème) ---------- */
  function steps(root) {
    var wrap = $('[data-steps]', root); if (!wrap) return null;
    var sticky = $('.ab-mf__sticky', wrap), rows = $$('[data-step-row]', wrap), imgs = $$('[data-step-img]', wrap), fill = $('[data-step-fill]', wrap);
    var n = rows.length, cur = -1;
    function set(i) {
      if (i === cur) return; cur = i;
      rows.forEach(function (r, k) { r.classList.toggle('st-row-on', k === i); });
      imgs.forEach(function (m, k) { m.classList.toggle('st-img-on', k === i); });
      if (fill) fill.style.height = ((i + 1) / n * 100) + '%';
    }
    $$('[data-step]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { jumpTo(wrap, +b.getAttribute('data-step'), n); });
    });
    return function () {
      if (wrap.offsetParent === null) return; /* masqué (mobile) ou retiré */
      var r = wrap.getBoundingClientRect(), vh = window.innerHeight, range = r.height - vh;
      var pinned = r.top <= 0 && r.bottom > vh, end = r.bottom <= vh;
      sticky.classList.toggle('is-pinned', pinned);
      sticky.classList.toggle('is-end', end && !pinned);
      var p = range > 0 ? clamp(-r.top / range, 0, 1) : 0;
      set(Math.min(n - 1, Math.floor(p * n)));
    };
  }

  /* ---------- scrollytelling mobile (position: sticky CSS) ---------- */
  function stepsMobile(root) {
    var wrap = $('[data-steps-m]', root); if (!wrap) return null;
    var imgs = $$('[data-mimg]', wrap), segs = $$('[data-mseg]', wrap), caps = $$('[data-mcap]', wrap);
    var n = caps.length, cur = -1;
    function set(i) {
      if (i === cur) return; cur = i;
      imgs.forEach(function (m, k) { m.classList.toggle('sm-img-on', k === i); });
      segs.forEach(function (m, k) { m.classList.toggle('sm-seg-on', k === i); });
      caps.forEach(function (m, k) { m.classList.toggle('sm-cap-on', k === i); });
    }
    $$('[data-mstep]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { jumpTo(wrap, +b.getAttribute('data-mstep'), n); });
    });
    return function () {
      if (wrap.offsetParent === null) return;
      var r = wrap.getBoundingClientRect(), range = r.height - window.innerHeight;
      var p = range > 0 ? clamp(-r.top / range, 0, 1) : 0;
      set(Math.min(n - 1, Math.floor(p * n)));
    };
  }

  /* ---------- galerie : chargement à l'approche ---------- */
  function gallery(root) {
    var sec = $('.ab-gal', root), imgs = $$('.ab-gal img[data-src]', root);
    if (!sec || !imgs.length) return;
    function load() { imgs.forEach(function (i) { if (!i.getAttribute('src')) i.src = i.dataset.src; }); }
    if (!hasIO) { load(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { load(); io.disconnect(); }
    }, { rootMargin: '600px 0px' });
    io.observe(sec);
  }

  /* ---------- modale média ---------- */
  function cineModal(root) {
    var cine = $('[data-ab-cine]', root); if (!cine) return null;
    var stage = $('[data-ab-cine-stage]', cine), last = null;
    function isOpen() { return cine.classList.contains('is-open'); }
    function open(kind, src, alt) {
      stage.innerHTML = '';
      var el = build(kind, src, alt); stage.appendChild(el);
      last = document.activeElement;
      if (!isOpen()) lock(true);
      cine.classList.add('is-open');
      play(el);
      focus($('[data-ab-cine-close]', cine));
    }
    function close() {
      if (!isOpen()) return;
      cine.classList.remove('is-open'); lock(false);
      var v = $('video', stage); if (v) v.pause();
      setTimeout(function () { if (!isOpen()) stage.innerHTML = ''; }, 400);
      focus(last);
    }
    cine.addEventListener('click', function (e) {
      if (e.target === cine || e.target === stage || e.target.closest('[data-ab-cine-close]')) close();
    });
    return { open: open, close: close, isOpen: isOpen };
  }

  /* ---------- carte de France + panneau Paris ---------- */
  function franceMap(root, cine) {
    var sec = $('.ab-fr', root); if (!sec || !cine) return null;
    var panel = $('[data-fr-panel]', sec), scrim = $('[data-fr-scrim]', sec), lastPin = null;
    function isOpen() { return !!panel && !panel.hidden; }
    function openPanel(pin) {
      if (!panel) return;
      lastPin = pin; scrim.hidden = false; panel.hidden = false; lock(true);
      focus($('[data-fr-close]', panel));
    }
    function close() {
      if (!isOpen()) return;
      panel.hidden = true; scrim.hidden = true; lock(false); focus(lastPin);
    }
    $$('.fr-pin', sec).forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.dataset.group) openPanel(p); else cine.open('video', pick(p));
      });
    });
    $$('.fr-row', sec).forEach(function (r) { r.addEventListener('click', function () { cine.open('video', pick(r)); }); });
    if (scrim) scrim.addEventListener('click', close);
    var c = panel && $('[data-fr-close]', panel); if (c) c.addEventListener('click', close);
    return { close: close, isOpen: isOpen };
  }

  /* ---------- encart jeu (fenêtre de dates) ---------- */
  function jeu(root) {
    $$('[data-ab-jeu]', root).forEach(function (s) {
      var st = Date.parse(s.dataset.start), en = Date.parse(s.dataset.end), now = Date.now();
      var show = (isNaN(st) || now >= st) && (isNaN(en) || now <= en);
      if (window.Shopify && window.Shopify.designMode) show = true;
      s.hidden = !show;
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    if (!root || root.__ab) return; root.__ab = true;
    heroVideo(root);
    snow(root);
    watchVids(root);
    gallery(root);
    var film = heroFilm(root), cine = cineModal(root), map = franceMap(root, cine);
    [film, cine, map].forEach(function (x) { if (x) escStack.push(x); });
    $$('[data-tv]', root).forEach(function (t) { var c = initTV(t, true); if (c) escStack.push(c); });
    $$('[data-tvm]', root).forEach(function (t) { var c = initTV(t, false); if (c) escStack.push(c); });
    reveal(root);
    var s1 = steps(root), s2 = stepsMobile(root);
    if (s1) scrollFns.push(s1);
    if (s2) scrollFns.push(s2);
    jeu(root);
    onWinScroll();
  }

  function boot() { $$('.anniversaire-bobochic').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* changement de breakpoint : bonne source pour la vidéo du hero */
  var onMq = function () { $$('.anniversaire-bobochic').forEach(heroVideo); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

  /* éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { $$('.anniversaire-bobochic', e.target).forEach(init); });
})();